export default __webpack_public_path__ + "static/3-236ac022bf727807d35b204bea04a55c.svg";